import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID, isDevMode } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';

import { Toast } from '@ionic-native/toast';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer } from '@ionic-native/file-transfer';

import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { PipesModule } from '../pipes/pipes.module';

import { SpinnerProvider } from '../providers/spinner/spinner';
import { AlertProvider } from '../providers/alert/alert';
import { NetworkProvider } from '../providers/network/network';
import { HttpProvider } from '../providers/http/http';
import { CardapioOnlineProvider } from '../providers/cardapio-online/cardapio-online';
import { ConfiguracaoConcessionariaProvider } from '../providers/configuracao-concessionaria/configuracao-concessionaria';
import { registerLocaleData } from '@angular/common';

import ptBr from '@angular/common/locales/pt';
import { ChecklistProvider } from '../providers/checklist/checklist';
import { AndroidPermissions } from '@ionic-native/android-permissions';

// import { PayPal } from '@ionic-native/paypal';

import { LottieAnimationViewModule } from 'ng-lottie';
import { EventLoggerProvider } from '../providers/event-logger/event-logger';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { DocumentViewer } from '@ionic-native/document-viewer';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility';
import { S3ServiceProvider } from '../providers/s3-service/s3-service';
import { Push } from '@ionic-native/push';
import { AtendimentoProvider } from '../providers/atendimento/atendimento';
import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
import { SocketProvider } from '../providers/socket/socket';
import { ConsumidorProvider } from '../providers/consumidor/consumidor';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { relatorioProvider } from '../providers/relatorio/relatorio';
import { AppVersion } from '@ionic-native/app-version';
import { Market } from '@ionic-native/market';
import { VersaoProvider } from '../providers/versao/versao';
import { Env } from '../environments/environment';
import { Camera } from '@ionic-native/camera';

let env;

// if(window.location.hostname === 'localhost'){
//   // env = azureHmlEnv;
//   // env = azureProdEnv;
//   env = devEnv;
//   // env = prodEnv;
//   // env = hmlEnv;
// }else{
//   switch (process.env.IONIC_ENV) {
//     case 'dev':
//       env = hmlEnv;
//       break;
//     case 'prod':
//       env = prodEnv;
//       // env = azureProdEnv;
//       break;
//       default:
//         env = hmlEnv;
//         break;
//   }
// }

// Object.entries(env).forEach(([key, value]) => {
//   process.env[key] = value;
// });

const config: SocketIoConfig = {
  url: Env.urlSocket,
  options: {
    transports: ['websocket'],  // impede polling (que é onde estoura CORS)
    upgrade: false,             // não tenta fallback para polling
    secure: true,               // necessário no Android para HTTPS
    rejectUnauthorized: false,  // evita erro SSL com WebView
    path: '/socket.io',         // necessário para Azure
    forceNew: true
  }
};
registerLocaleData(ptBr);

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    SocketIoModule.forRoot(config),
    IonicModule.forRoot(MyApp,
      {
        backButtonText: 'Voltar',
        preloadModules: true,
        mode: 'md',
        platforms: {
          ios: {
            statusbarPadding: true,
            scrollAssist: true,
            autoFocusAssist: true,
            scrollPadding: true

          }

        }
      }),
    HttpClientModule,
    IonicStorageModule.forRoot(),
    LottieAnimationViewModule,
    PipesModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    BarcodeScanner,
    AppVersion,
    Market,
    CardapioOnlineProvider,
    ConfiguracaoConcessionariaProvider,
    ChecklistProvider,
    Toast,
    SpinnerProvider,
    AlertProvider,
    NetworkProvider,
    HttpProvider,
    ScreenOrientation,
    File,
    FileOpener,
    FileTransfer,
    AndroidPermissions,
    EventLoggerProvider,
    FirebaseAnalytics,
    // ThemeableBrowser,
    InAppBrowser,
    MobileAccessibility,
    DocumentViewer,
    S3ServiceProvider,
    Push,
    AtendimentoProvider,
    relatorioProvider,
    ConsumidorProvider,
    // PayPal,
    SocketProvider,
    VersaoProvider,
    Camera
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts